import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStore = defineStore("app", () => {
	const toaster = ref<any>(null);

	return { toaster };
});
